export class PaycodeActions {
  static readonly LOAD_REQUEST = 'sender/paycode/LOAD_REQUEST';
  static readonly LOAD_SUCCESS = 'sender/paycode/LOAD_SUCCESS';
  static readonly LOAD_ERROR = 'sender/paycode/LOAD_ERROR';

  static readonly LOAD_LIST_SUCCESS = 'sender/paycode/LOAD_LIST_SUCCESS';

  static readonly SET_CURRENT_PAGE = 'sender/paycode/SET_CURRENT_PAGE';
}
